<template>
  <v-container>
    <v-form @submit.prevent="submit">
      <v-text-field
        v-model="device.setInfo.plateNo"
        label="차량번호"
        :hint="setInfo.plateNo ? setInfo.plateNo + ' 진행중' : ''"
        persistent-hint
      ></v-text-field>
      <group-selector v-slot="{ items, loading, error }">
        <v-select
          v-model="device._gr"
          label="노선"
          :items="items"
          :loading="loading"
        ></v-select>
      </group-selector>
      <v-select
        v-model="device.fuelType"
        label="유종"
        :items="fuelTypes"
      ></v-select>
      <v-text-field
        label="차대번호"
        v-model="device.setInfo.vin"
        :hint="setInfo.vin ? setInfo.vin + ' 진행중' : ''"
        persistent-hint
      ></v-text-field>
      <v-text-field
        label="사업자번호"
        v-model="device.setInfo.companyNo"
        :hint="setInfo.companyNo ? setInfo.companyNo + ' 진행중' : ''"
        persistent-hint
      ></v-text-field>
      <v-btn type="submit" color="success">적용</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { getDevice, updateDevice } from '@/api'

export default {
  async beforeRouteEnter (to, from, next) {
    const _id = to.params._id

    if (!_id) return next()

    try {
      const device = await getDevice(_id)
      console.log(device)
      next(vm => {
        vm.id = _id
        vm.device._gr = device._gr
        vm.device.fuelType = device.fuelType
        vm.device.setInfo.plateNo = device.info.plateNo
        vm.device.setInfo.vin = device.info.vin
        vm.device.setInfo.companyNo = device.info.companyNo
        if (device.setInfo) {
          vm.setInfo.plateNo = device.setInfo.plateNo
          vm.setInfo.vin = device.setInfo.vin
          vm.setInfo.companyNo = device.setInfo.companyNo
        }
      })
    } catch (err) {
      console.error(err.message)
      next()
    }
  },
  data () {
    return {
      groups: [],
      fuelTypes: [
        {
          text: '미지정',
          value: 0
        },
        {
          text: '경유',
          value: 1
        },
        {
          text: 'CNG',
          value: 2
        }
      ],
      id: null,
      device: {
        _gr: '',
        fuelType: 0,
        setInfo: {
          plateNo: '',
          vin: '',
          companyNo: ''
        }
      },
      setInfo: {
        plateNo: '',
        vin: '',
        companyNo: ''
      }
    }
  },
  methods: {
    async submit () {
      if (this.loading) return
      this.loading = true
      try {
        const $promise = this.id ? updateDevice(this.id, this.device) : Promise.resolve()/* createDevice(this.device) */
        await $promise
        alert('성공')
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }

      this.loading = false
    }
  }
}
</script>
